// extracted by mini-css-extract-plugin
module.exports = {"platformContainer":"_5i8flti3zug1GaXqDk8b0A==","platformBit":"hOw-UsqoyU64Bt02yCyDyQ==","platformName":"PkYX7FwKpPtxoqdKQOCRcg==","icon":"L37hF27bsTpjRqtFZKYdLQ=="};